import {
    TDerivedResolveOptions,
    TResolveAssetPayload,
    TResolveFormData,
    TSelectableAsset,
} from './useIssueResolution.types'

export const buildResolveAssetPayload = (
    asset: Partial<TAsset>
): TResolveAssetPayload => ({
    name:
        asset.asset_type === 'cloud_app' ? asset.provider_name : asset.hostname,
    type: asset.asset_type,
    external_manager_issue_id:
        asset.asset_type === 'cloud_app' || asset.asset_type === 'user'
            ? (asset as Partial<TCloudAppIssueAsset>).external_issue_id ||
              (asset.id as string)
            : null,
})

export const getSelectableAssets = (issue: TIssue): TSelectableAsset[] => {
    const assets = (issue.assets ?? []) as Partial<TAsset>[]
    const devices =
        issue.issue_type === 'GENERAL' && issue.devices
            ? (issue.devices as Partial<TAsset>[])
            : []

    return [...assets, ...devices].map((asset) => ({
        id: String(asset.id ?? asset.hostname),
        hostname: asset.hostname ?? '',
        asset,
        payload: buildResolveAssetPayload(asset),
    }))
}

export const getSelectableTechnologies = (issue: TIssue): TTechnology[] => {
    if (
        issue.issue_type !== 'GENERAL' &&
        issue.issue_type !== 'FRAUD_DEFENSE'
    ) {
        return []
    }
    return issue.technologies ?? []
}

const FIXED_VALUE = 'fixed'
const NOT_AN_ISSUE_VALUE = 'not an issue'

const hasValue =
    (target: string) =>
    ({ value }: SelectionOption) =>
        value.trim().toLowerCase() === target

export const deriveResolveOptions = ({
    actions,
}: TResolveFormData): TDerivedResolveOptions => {
    const notAnIssueAction = actions.find(hasValue(NOT_AN_ISSUE_VALUE))
    const fixedAction = actions.find(hasValue(FIXED_VALUE))

    return { fixedAction, notAnIssueAction }
}
